// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "top_wrapper-23GTp";
var _4 = "header-5T7LO";
var _5 = "form-2w8_S";
var _6 = "input__wrapper-2ghPd";
var _7 = "passengerName-HB8xb";
var _8 = "input-_tvSV";
var _9 = "footer-1TZdL";
var _a = "mobileFullscreen__root-3IlxS";
var _b = "mobileFullscreen__paper-WOZgi";
var _c = "mobileFullscreen__content-3x3Bj";
var _d = "content__wrapper-3tPkp";
var _e = "content-3MLgr";
var _f = "title-1XS3P";
export { _1 as "__esModule", _2 as "mobile", _3 as "top_wrapper", _4 as "header", _5 as "form", _6 as "input__wrapper", _7 as "passengerName", _8 as "input", _9 as "footer", _a as "mobileFullscreen__root", _b as "mobileFullscreen__paper", _c as "mobileFullscreen__content", _d as "content__wrapper", _e as "content", _f as "title" }
export default { "__esModule": _1, "mobile": _2, "top_wrapper": _3, "header": _4, "form": _5, "input__wrapper": _6, "passengerName": _7, "input": _8, "footer": _9, "mobileFullscreen__root": _a, "mobileFullscreen__paper": _b, "mobileFullscreen__content": _c, "content__wrapper": _d, "content": _e, "title": _f }
